<ng-container *ngIf="dialog$ | async as dialog">
  <div class="paybee-modal-header">
    <div class="modal-title">{{ dialog.initialState.modalTitle || "Are you sure?" }}</div>
  </div>
  <div class="modal-body">
    <div *ngIf="!dialog.initialState.innerHtml" class="text-center">{{ dialog.initialState.text }}</div>
    
    <ng-container *ngIf="dialog.initialState.innerHtml">
      <div class="text-center modal-body__title"><b>{{ dialog.initialState.text }}</b></div>
      <div class="pt-2" [innerHTML]="dialog.initialState.innerHtml"></div>
    </ng-container>

  </div>
  <div class="modal-footer paybee-modal-footer">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="close(dialog, false)">{{ dialog.initialState.buttonCancel || "Cancel" }}</button>
      </div>
      @if(!dialog.initialState?.hideSuccessButton){
        <div class="col-4">
          <button type="button" class="btn btn--paybee btn--success btn--md text-center w-100" (click)="close(dialog, true)">{{ dialog.initialState.buttonConfirm || "Confirm" }}</button>
        </div>
      }
    </div>
  </div>  
</ng-container>
